import React from 'react'
import createMarkup from '../../../helpers/createMarkup'
import { Row, Col, Button } from 'reactstrap'

export default function ItemNotAnswered(props) {
  

  let markup
  let output = <div></div>
  if (props.answer) {
    markup = createMarkup(props.answer)
    output = <div style={{ "fontSize": props.fontValue }} dangerouslySetInnerHTML={markup}></div>
  }

  let color = 'secondary'
  

  // classNames for our Row
  

  let percentChosen = null
  let buttonGrid = { xs: 2, sm: 1, md: 2, lg: 2, xl: 1 }
  let answerGrid = { xs: 10, sm: 11, md: 10, lg: 10, xl: 11 }
  let answerBorderGrid = { xs: 10, sm: 11, md: 10, lg: 10, xl: 12 }


  return (
    <Row className={`answer-choice-row `}>
      <Col {...answerGrid} className='answer-choice-text'>
        <div className='answer-choice-bg m2clickable'>
          <i style={{color:'#C2CFCC'}}>{output}</i>
        </div>
        
      
      </Col>
      <Col {...answerBorderGrid} className='answer-choice-text'>
       
        <div style={{borderTop:'1px solid #e0e5e9',width:'100%' }}>
          &nbsp;
        </div>
      </Col>
    </Row>
  )
}


// WEBPACK FOOTER //
// ./src/components/Assessment/AssessTest/ItemNotAnswered.js